export const MONTHLY_INVOICING_PAGE_STATE_KEY = 'monthlyInvoicing';
export const ALL_INVOICES_PAGE_STATE_KEY = 'allInvoicesIndex';
export const PROJECTS_INDEX_PAGE_STATE_KEY = 'projectsIndex';
export const TIME_TRACKING_INDEX_PAGE_KEY = 'timeTrackingIndex';

export const ADMIN_USERS_INDEX_PAGE_STATE_KEY = 'adminUsersIndex';

export const STAFF_MEMBERS_INDEX_PAGE_STATE_KEY = 'staffMembersIndex';

export const HR_STATISTICS_PAGE_STATE_KEY = 'hrStatistics';

export const PROJECT_DETAILS_PAGE_STATE_KEY = (projectId:string) =>'projectDetails-' + projectId;

export const PROJECTS_INVOICES_TABLE_PAGE_STATE_KEY = (projectId:string) => 'projectsInvoices-' + projectId;

export const PROJECT_DESCRIPTION_VIEW_PAGE_STATE_KEY = 'projectDescriptionsIndex';

const INVOICES_BASE_PAGE_KEY = 'invoices-';
export const INVOICES_SHARED_FILTER_VALUES= INVOICES_BASE_PAGE_KEY + "shared-filter";
export const INVOICES_PENDING_PAGE_KEY = INVOICES_BASE_PAGE_KEY + "pending";
export const INVOICES_DRAFT_PAGE_KEY = INVOICES_BASE_PAGE_KEY + "draft";
export const INVOICES_UNPAID_PAGE_KEY = INVOICES_BASE_PAGE_KEY + "unpaid";
export const INVOICES_PROCESSED_PAGE_KEY = INVOICES_BASE_PAGE_KEY + "all";
export const INVOICES_IMPORT_ERRORS_PAGE_KEY = INVOICES_BASE_PAGE_KEY + "import-errors";